// @flow

import type { PricingPlan } from '@toggl/auth'

export const pricingPlanUrls = new Map<PricingPlan, string>([
  [102, '/track/signup/'],
])
